import { STLExporter } from 'three/examples/jsm/exporters/STLExporter.js';
import { PLYExporter } from 'three/examples/jsm/exporters/PLYExporter.js';

export function Download(blob, filename) {
  console.log("Save", filename);

  var link = document.createElement( 'a' );
  link.style.display = 'none';
  document.body.appendChild( link );
      
  link.href = URL.createObjectURL( blob );
  link.download = filename;
  link.click();
}

export function SavePLY(mesh) {
  var exporter = new PLYExporter();
  var result = exporter.parse( mesh, { binary: true } );
  return new Blob( [ result ], { type: 'text/plain' } );
}
export function SaveSTL(mesh) {
  var exporter = new STLExporter();
  var result = exporter.parse( mesh, { binary: true } );
  return new Blob( [ result ], { type: 'text/plain' } );
}

